import { render, staticRenderFns } from "./renewalPage.vue?vue&type=template&id=fb48476e&"
import script from "./renewalPage.vue?vue&type=script&lang=js&"
export * from "./renewalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports